/*
 * sections/custom-combo-section.liquid - kit carousel arrows (desktop) and
 * arrow positioning. Loaded with `defer`; initialises every
 * `.inv-combo-section` on the page and re-initialises a section the theme
 * editor reloads.
 */
(function () {
  if (window.invComboCarouselInit) return;
  window.invComboCarouselInit = true;

  function initializeEverydayCareKitsCarousel(sectionElement) {
    if (!sectionElement) return;

    var carousel = sectionElement.querySelector('[data-everyday-care-kits-carousel]');
    var scroller = sectionElement.querySelector('.everyday-care-kits__track');
    var previousButton = sectionElement.querySelector('.everyday-care-kits__arrow--prev');
    var nextButton = sectionElement.querySelector('.everyday-care-kits__arrow--next');

    if (!carousel || !scroller || !previousButton || !nextButton || carousel.dataset.initialized === 'true') {
      return;
    }

    carousel.dataset.initialized = 'true';

    function isDesktop() {
      return window.innerWidth > 768;
    }

    function getVisibleCards() {
      return Array.prototype.filter.call(scroller.querySelectorAll('.everyday-care-kit-card'), function (card) {
        return card.offsetParent !== null;
      });
    }

    function updateArrowPosition() {
      var cards = getVisibleCards();

      if (!cards.length) return;

      var carouselRect = carousel.getBoundingClientRect();
      var scrollerRect = scroller.getBoundingClientRect();
      var firstCardRect = cards[0].getBoundingClientRect();

      carousel.style.setProperty(
        '--everyday-kits-arrow-prev-left',
        scrollerRect.left - carouselRect.left + 'px'
      );
      carousel.style.setProperty(
        '--everyday-kits-arrow-next-left',
        scrollerRect.right - carouselRect.left + 'px'
      );
      carousel.style.setProperty(
        '--everyday-kits-arrow-top',
        firstCardRect.top - carouselRect.top + firstCardRect.height / 2 + 'px'
      );
    }

    function updateButtons() {
      var maximumScrollLeft = Math.max(0, Math.round(scroller.scrollWidth - scroller.clientWidth));
      var hasScrollableContent = maximumScrollLeft > 5;

      if (!isDesktop() || !hasScrollableContent) {
        previousButton.style.display = 'none';
        nextButton.style.display = 'none';
        previousButton.disabled = true;
        nextButton.disabled = true;
        return;
      }

      previousButton.style.display = '';
      nextButton.style.display = '';

      var currentScrollLeft = Math.max(0, Math.round(scroller.scrollLeft));
      var threshold = 20;

      previousButton.disabled = currentScrollLeft <= threshold;
      nextButton.disabled = currentScrollLeft >= maximumScrollLeft - threshold;
    }

    function getScrollDistance() {
      var cards = getVisibleCards();

      if (!cards.length) {
        return scroller.clientWidth * 0.8;
      }

      if (cards[1]) {
        return Math.round(cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left);
      }

      var sliderStyles = window.getComputedStyle(scroller);
      var gap = parseFloat(sliderStyles.columnGap || sliderStyles.gap) || 0;

      return cards[0].getBoundingClientRect().width + gap;
    }

    function updateAfterLayout() {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          // The arrows are hidden below 769px, so skip the layout reads there
          // (each one forces a style/layout flush of the whole page on load).
          if (isDesktop()) updateArrowPosition();
          updateButtons();
        });
      });
    }

    previousButton.addEventListener('click', function () {
      if (!isDesktop()) return;

      scroller.scrollBy({
        left: -getScrollDistance(),
        behavior: 'smooth',
      });
    });

    nextButton.addEventListener('click', function () {
      if (!isDesktop()) return;

      scroller.scrollBy({
        left: getScrollDistance(),
        behavior: 'smooth',
      });
    });

    scroller.addEventListener('scroll', updateButtons, {
      passive: true,
    });

    window.addEventListener('resize', updateAfterLayout);
    window.addEventListener('load', updateAfterLayout);

    updateAfterLayout();
    window.setTimeout(updateAfterLayout, 100);
    window.setTimeout(updateAfterLayout, 300);
  }

  function initializeAll() {
    document.querySelectorAll('.inv-combo-section').forEach(initializeEverydayCareKitsCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.classList && event.target.classList.contains('inv-combo-section')) {
      initializeEverydayCareKitsCarousel(event.target);
    }
  });
})();
